export const AVAILABLE_SURVIVOR_TAGS = [
  'aura',
  'chase',
  'pallet',
  'disparition',
  'stealth',
  'heal',
  'boon',
  'totem',
  'item',
  'gen',
  'skillcheck',
  'anti_tunnel',
  'anti_slug',
  'pickup_denial',
  'endgame',
  'basement',
  'teamplay',
  'save',
  'obsession'
]

export const survivorTagOverrides = {
  ace_in_the_hole: ['item'],
  adrenaline: ['endgame', 'heal', 'chase'],
  aftercare: ['aura', 'teamplay'],
  alert: ['aura'],
  autodidact: ['heal', 'skillcheck'],
  balanced_landing: ['chase'],
  boil_over: ['pickup_denial', 'anti_slug'],
  bond: ['aura', 'teamplay'],
  borrowed_time: ['anti_tunnel', 'save', 'teamplay'],
  botany_knowledge: ['heal'],
  breakdown: ['anti_tunnel', 'pickup_denial'],
  calm_spirit: ['stealth', 'totem'],
  dance_with_me: ['disparition', 'chase'],
  dark_sense: ['aura'],
  dead_hard: ['anti_tunnel', 'chase'],
  decisive_strike: ['anti_tunnel', 'obsession'],
  deja_vu: ['gen', 'aura'],
  deliverance: ['save', 'anti_tunnel'],
  detectives_hunch: ['aura', 'gen', 'totem'],
  distortion: ['stealth', 'aura', 'disparition'],
  diversion: ['stealth', 'disparition'],
  empathy: ['aura', 'heal', 'teamplay'],
  head_on: ['chase', 'save'],
  hope: ['endgame', 'chase'],
  iron_will: ['stealth', 'disparition'],
  kindred: ['aura', 'teamplay', 'save'],
  leader: ['teamplay'],
  left_behind: ['endgame', 'aura'],
  lightweight: ['disparition', 'stealth'],
  lithe: ['chase', 'disparition'],
  no_mither: ['anti_slug', 'disparition'],
  no_one_left_behind: ['endgame', 'heal', 'save'],
  object_of_obsession: ['obsession', 'aura'],
  open_handed: ['aura', 'teamplay'],
  pharmacy: ['item', 'heal'],
  plunderers_instinct: ['item', 'aura'],
  poised: ['gen', 'disparition', 'aura'],
  premonition: ['aura', 'stealth'],
  prove_thyself: ['gen', 'teamplay'],
  quick_and_quiet: ['disparition', 'chase', 'stealth'],
  resilience: ['chase', 'gen', 'heal'],
  saboteur: ['save', 'pickup_denial', 'aura'],
  self_care: ['heal'],
  slippery_meat: ['save'],
  small_game: ['totem', 'aura'],
  sole_survivor: ['endgame', 'obsession', 'aura'],
  solidarity: ['heal', 'teamplay'],
  spine_chill: ['aura', 'chase'],
  sprint_burst: ['chase'],
  stake_out: ['skillcheck', 'gen'],
  streetwise: ['item', 'aura', 'loot'],
  technician: ['gen', 'stealth', 'skillcheck'],
  tenacity: ['anti_slug', 'pickup_denial', 'disparition'],
  this_is_not_happening: ['skillcheck'],
  unbreakable: ['anti_slug'],
  up_the_ante: ['save', 'teamplay'],
  urban_evasion: ['stealth'],
  vigil: ['chase', 'teamplay'],
  wake_up: ['endgame', 'aura', 'teamplay'],
  well_make_it: ['save', 'heal'],
  were_gonna_live_forever: ['anti_slug', 'save', 'teamplay'],
  windows_of_opportunity: ['chase', 'pallet', 'aura'],
  buckle_up: ['anti_slug', 'aura', 'save'],
  flip_flop: ['pickup_denial', 'anti_slug'],
  mettle_of_man: ['save', 'chase'],
  baby_sitter: ['anti_tunnel', 'save', 'aura'],
  camaraderie: ['save', 'teamplay'],
  second_wind: ['heal', 'anti_tunnel'],
  better_together: ['gen', 'aura', 'teamplay'],
  fixated: ['chase', 'stealth', 'disparition'],
  inner_strength: ['heal', 'totem'],
  breakout: ['save', 'pickup_denial', 'teamplay'],
  any_means_necessary: ['pallet', 'chase'],
  lucky_break: ['disparition', 'stealth', 'heal'],
  off_the_record: ['anti_tunnel', 'stealth', 'aura'],
  red_herring: ['gen', 'stealth'],
  for_the_people: ['heal', 'save', 'obsession'],
  soul_guard: ['anti_slug', 'pickup_denial'],
  blood_pact: ['obsession', 'aura', 'teamplay'],
  repressed_alliance: ['gen'],
  desperate_measures: ['heal', 'save'],
  built_to_last: ['item'],
  visionary: ['gen', 'aura'],
  appraisal: ['item'],
  deception: ['stealth', 'disparition', 'chase'],
  power_struggle: ['pickup_denial', 'pallet'],
  fast_track: ['gen', 'skillcheck'],
  self_preservation: ['stealth', 'disparition'],
  smash_hit: ['chase', 'pallet'],
  bite_the_bullet: ['heal', 'stealth', 'disparition'],
  blast_mine: ['gen', 'aura'],
  counterforce: ['totem', 'aura'],
  flashbang: ['save', 'item'],
  resurgence: ['heal', 'anti_tunnel'],
  rookie_spirit: ['gen', 'aura', 'skillcheck'],
  circle_of_healing: ['boon', 'heal'],
  shadow_step: ['boon', 'stealth', 'disparition'],
  clairvoyance: ['totem', 'aura'],
  exponential: ['boon', 'anti_slug'],
  corrective_action: ['skillcheck', 'gen', 'teamplay'],
  overcome: ['chase', 'disparition'],
  dark_theory: ['boon', 'chase'],
  empathic_connection: ['heal', 'aura', 'teamplay'],
  parental_guidance: ['pallet', 'disparition', 'chase'],
  inner_focus: ['aura', 'teamplay'],
  residual_manifest: ['item', 'save'],
  overzealous: ['totem', 'gen'],
  better_than_new: ['heal', 'teamplay'],
  hyperfocus: ['skillcheck', 'gen'],
  low_profile: ['endgame', 'stealth', 'disparition'],
  reactive_healing: ['heal', 'teamplay'],
  reassurance: ['save', 'teamplay', 'anti_tunnel'],
  wiretap: ['gen', 'aura'],
  potential_energy: ['gen'],
  fogwise: ['skillcheck', 'aura', 'gen'],
  quick_gambit: ['chase', 'gen', 'aura'],
  background_player: ['save', 'pickup_denial', 'chase'],
  blood_rush: ['anti_tunnel', 'chase'],
  cut_loose: ['chase', 'disparition'],
  friendly_competition: ['gen', 'teamplay'],
  teamwork_collective_stealth: ['heal', 'teamplay', 'stealth'],
  teamwork_power_of_two: ['heal', 'teamplay', 'chase'],
  made_for_this: ['heal', 'chase', 'save'],
  scavenger: ['item', 'gen', 'skillcheck'],
  troubleshooter: ['chase', 'gen', 'aura'],
  dramaturgy: ['chase'],
  scene_partner: ['aura'],
  plot_twist: ['heal', 'anti_slug', 'disparition'],
  chemical_trap: ['pallet', 'chase', 'gen'],
  light_footed: ['stealth', 'chase'],
  lucky_star: ['stealth', 'aura'],
  boon_illumination: ['boon', 'aura', 'gen'],
  champion_of_light: ['item', 'chase', 'save'],
  deadline: ['skillcheck'],
  invocation_weaving_spiders: ['basement', 'gen'],
  strength_in_shadows: ['basement', 'heal', 'aura'],
  wicked: ['basement', 'anti_tunnel', 'aura'],
  bardic_inspiration: ['skillcheck', 'gen', 'teamplay'],
  mirrored_illusion: ['stealth', 'gen'],
  still_sight: ['aura', 'gen', 'item'],
  specialist: ['chest', 'gen', 'skillcheck'],
  finesse: ['chase'],
  hardened: ['totem', 'item', 'aura'],
  exultation: ['item', 'pallet', 'chase'],
  eyes_of_belmont: ['aura', 'gen'],
  moment_of_glory: ['item', 'heal'],
  clean_break: ['heal', 'teamplay'],
  treacherous_crows: ['basement', 'aura'],
  shoulder_the_burden: ['save', 'anti_tunnel', 'teamplay'],
  do_no_harm: ['heal', 'skillcheck', 'teamplay'],
  duty_of_care: ['save', 'chase', 'teamplay'],
  rapid_response: ['aura', 'chase'],
  apocalyptic_ingenuity: ['item', 'pallet', 'chase'],
  come_and_get_me: ['save', 'anti_tunnel', 'disparition'],
  teamwork_toughen_up: ['teamplay', 'pallet', 'disparition'],
  conviction: ['anti_slug', 'heal'],
  last_stand: ['chase', 'pallet'],
  teamwork_throw_down: ['teamplay', 'pallet', 'save'],
  ghost_notes: ['chase', 'disparition'],
  one_two_three_four: ['skillcheck', 'gen', 'teamplay'],
  road_life: ['skillcheck', 'gen', 'heal'],
  bada_bada_boom: ['chase', 'pallet', 'gen'],
  change_of_plan: ['item', 'heal', 'gen'],
  teamwork_full_circuit: ['skillcheck', 'gen', 'teamplay'],
  extrasensory_perception: ['aura', 'stealth'],
  teamwork_soft_spoken: ['gen', 'teamplay', 'stealth'],
  we_see_you: ['aura', 'teamplay'],
  a_place_for_us: ['heal', 'stealth', 'teamplay'],
  five_moves_ahead: ['chase', 'pallet', 'aura'],
  flow_state: ['heal', 'totem', 'save'],
  wide_open_throttle: ['chase', 'pallet', 'haste'],
  lend_a_hand: ['heal', 'totem', 'teamplay'],
  cross_examination: ['stealth', 'information', 'chase']
}

export default survivorTagOverrides
